/* @flow strict */

export const columns = (): [] => {
  return [
    {
        selector: 'first_name',
        name: 'First Name',
        sortable: true
    },
    {
        selector: 'last_name',
        name: 'Last Name',
        sortable: true
    },
    {
        selector: 'email_address',
        name: 'Email',
        sortable: true
    },
    {
        selector: 'phone_number',
        name: 'Phone',
        sortable: true
    },
    {
        selector: 'remark',
        name: 'Notes',
        sortable: true
    }
    // {
    //   selector: 'question_answers',
    //   name: 'Birth Month (we may send you a special promotion)',
    //   sortable: true
    // }
  ];
};
